import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import store from '@/store';
import router from '@/router';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

// Track active requests
let requests = 0;
let loaderTimer = null;

// REQUEST
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const skipLoader = (config as any).skipLoader;

  if (!skipLoader && !store.state.isInitializing) {
    requests++;

    clearTimeout(loaderTimer);

    loaderTimer = setTimeout(() => {
      if (requests > 0) {
        store.commit('SET_LOADING', true);
      }
    }, 150);
  }

  const headers = (config.headers || {}) as any;

  let token = store.state.access;

  if (!token) {
    token = localStorage.getItem('access');
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  config.headers = headers;

  return config;
});

// RESPONSE SUCCESS
api.interceptors.response.use(
  (response: AxiosResponse) => {
    const skipLoader = (response.config as any)?.skipLoader ?? false;

    if (!skipLoader && !store.state.isInitializing) {
      requests = Math.max(requests - 1, 0);

      if (requests === 0) {
        clearTimeout(loaderTimer);
        loaderTimer = null;
        store.commit('SET_LOADING', false);
      }
    }

    return response;
  },
  // RESPONSE ERROR
  (error: AxiosError<any>) => {
    const skipLoader = (error.config as any)?.skipLoader ?? false;

    if (!skipLoader && !store.state.isInitializing) {
      requests = Math.max(requests - 1, 0);

      if (requests === 0) {
        clearTimeout(loaderTimer);
        loaderTimer = null;
        store.commit('SET_LOADING', false);
      }
    }

    const status = error.response?.status;

    // Session expired
    if (status === 401 || status === 440) {
      store.commit('CLEAR_TOKENS');

      if (router.currentRoute.value.path !== '/log-in') {
        router.push('/log-in');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
